import { apiFetch } from './client';
import type { LoginResponse } from './types';

export const login = (email: string, password: string) =>
  apiFetch<LoginResponse>('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });

export interface RegisterParams {
  email: string;
  name: string;
  password: string;
  orgName: string;
}

// Registers a user + creates their org (owner) and returns tokens — same shape as login, so the
// caller is logged in immediately.
export const register = (params: RegisterParams) =>
  apiFetch<LoginResponse>('/auth/register', {
    method: 'POST',
    body: JSON.stringify(params),
  });

export const refresh = (refreshToken: string) =>
  apiFetch<LoginResponse>('/auth/refresh', {
    method: 'POST',
    body: JSON.stringify({ refreshToken }),
  });

export const logout = () =>
  apiFetch<{ success: boolean }>('/auth/logout', { method: 'POST' });
